import React, { useState } from 'react';
import './EditProfileModal.css';

const EditProfileModal = ({ profile, onClose, onSave }) => {

  const [name, setName] = useState(profile?.Name || '');
  const originalPhone = profile?.Phone || '';

  const handleSaveClick = () => {
    onSave(name.trim(), originalPhone);
    onClose();
  };

  return (
    <div className="edit-profile-backdrop">
      <div className="edit-profile-modal">
        <h2>Edit Profile</h2>

        <div className="edit-profile-input-group">
          <label className="edit-profile-label">Full Name</label>
          <input
            type="text"
            placeholder="Enter new name"
            value={name}
            onChange={e => setName(e.target.value)}
            className="edit-profile-input"
          />
        </div>

        <div className="edit-profile-input-group">
          <label className="edit-profile-label">Phone Number</label>
          <input
            type="tel"
            value={originalPhone}
            disabled
            className="edit-profile-input"
          />
        </div>

        <div className="edit-profile-actions">
          <button
            onClick={onClose}
            className="edit-profile-button cancel"
          >
            Cancel
          </button>
          <button
            onClick={handleSaveClick}
            className="edit-profile-button save"
            disabled={name.trim().length === 0}
          >
            Save Changes
          </button>
        </div>
      </div>
    </div>
  );
};

export default EditProfileModal;
